import { TranslocoService } from '@jsverse/transloco';

export class EnvironmentalEffectTexts {
    climateChange!: EnvironmentalEffectClarification;
    acidification!: EnvironmentalEffectClarification;
    ecotoxicityFreshwater!: EnvironmentalEffectClarification;
    eutrophicationFreshwater!: EnvironmentalEffectClarification;
    eutrophicationMarine!: EnvironmentalEffectClarification;
    eutrophicationTerrestrial!: EnvironmentalEffectClarification;
    cancerogenicEffects!: EnvironmentalEffectClarification;
    noncancerogenicEffects!: EnvironmentalEffectClarification;
    ionizingRadiation!: EnvironmentalEffectClarification;
    ozoneLayerDepletion!: EnvironmentalEffectClarification;
    photochemicalOzoneCreation!: EnvironmentalEffectClarification;
    respiratoryEffects!: EnvironmentalEffectClarification;
    waterScarcity!: EnvironmentalEffectClarification;
    fossils!: EnvironmentalEffectClarification;
    landUse!: EnvironmentalEffectClarification;
    mineralsAndMetals!: EnvironmentalEffectClarification;
}

export interface EnvironmentalEffectClarification {
    description: string;
    unit: string;
}

export class LifeCycleStageTexts {
    primaryMaterials = '';
    secondaryMaterials = '';
}

export class TextsLcaData {

    environmentalEffectsTexts: EnvironmentalEffectTexts;
    lifeCycleStagesTexts: LifeCycleStageTexts;
    language = '';

    constructor(public translate: TranslocoService) {
        this.environmentalEffectsTexts = new EnvironmentalEffectTexts();
        this.lifeCycleStagesTexts = new LifeCycleStageTexts();
        this.language = translate.getActiveLang();
        this.setTooltips();
    }

    setTooltips() {
      this.setEnvironmentalEffectsTooltips();
      this.setLifecycleStageTooltips();
    }

    private setLifecycleStageTooltips() {
      this.lifeCycleStagesTexts.primaryMaterials = this.translate.translate('analysis.lifecycleAnalysis.tooltips.primaryMaterials');
      this.lifeCycleStagesTexts.secondaryMaterials = this.translate.translate('analysis.lifecycleAnalysis.tooltips.secondaryMaterials');
    }

    private setEnvironmentalEffectsTooltips() {
      this.environmentalEffectsTexts.climateChange = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.climateChange.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.climateChange.unit')
      }

      this.environmentalEffectsTexts.acidification = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.acidification.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.acidification.unit')
      }

      this.environmentalEffectsTexts.ecotoxicityFreshwater = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ecotoxicityFreshwater.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ecotoxicityFreshwater.unit')
      }

      this.environmentalEffectsTexts.eutrophicationFreshwater = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationFreshwater.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationFreshwater.unit')
      }

      this.environmentalEffectsTexts.eutrophicationMarine = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationMarine.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationMarine.unit')
      }

      this.environmentalEffectsTexts.eutrophicationTerrestrial = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationTerrestrial.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.eutrophicationTerrestrial.unit')
      }

      this.environmentalEffectsTexts.cancerogenicEffects = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.cancerogenicEffects.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.cancerogenicEffects.unit')
      }

      this.environmentalEffectsTexts.noncancerogenicEffects = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.noncancerogenicEffects.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.noncancerogenicEffects.unit')
      }

      this.environmentalEffectsTexts.ionizingRadiation = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ionizingRadiation.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ionizingRadiation.unit')
      }

      this.environmentalEffectsTexts.ozoneLayerDepletion = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ozoneLayerDepletion.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.ozoneLayerDepletion.unit')
      }

      this.environmentalEffectsTexts.photochemicalOzoneCreation = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.photochemicalOzoneCreation.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.photochemicalOzoneCreation.unit')
      }

      this.environmentalEffectsTexts.respiratoryEffects = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.respiratoryEffects.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.respiratoryEffects.unit')
      }

      this.environmentalEffectsTexts.waterScarcity = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.waterScarcity.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.waterScarcity.unit')
      }

      this.environmentalEffectsTexts.fossils = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.fossils.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.fossils.unit')
      }

      this.environmentalEffectsTexts.landUse = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.landUse.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.landUse.unit')
      }

      this.environmentalEffectsTexts.mineralsAndMetals = {
        description: this.translate.translate('analysis.lifecycleAnalysis.tooltips.mineralsAndMetals.description'),
        unit: this.translate.translate('analysis.lifecycleAnalysis.tooltips.mineralsAndMetals.unit')
      }
    }
}
